






import Vue from 'vue'
export default Vue.extend({
  computed: {
    cases() {
      if (this.$store.getters['availableCases']) {
        return Object.values(this.$store.getters['availableCases'])
      } else {
        return null
      }
    },
    currentCaseId: {
      get() {
        return this.$store.getters['currentCaseId']
      },
      set(value) {
        this.$store.commit({ type: 'setCurrentCaseId', caseId: value })
      },
    },
  },
})
